import { useEffect } from 'react';

export function useLockBodyScroll(isLocked) {
  useEffect(() => {
    if (!isLocked || typeof document === 'undefined') {
      return undefined;
    }

    const { body } = document;
    const currentCount = Number(body.dataset.modalScrollLockCount || '0');

    if (currentCount === 0) {
      body.dataset.modalPreviousOverflow = body.style.overflow || '';
      body.style.overflow = 'hidden';
    }

    body.dataset.modalScrollLockCount = String(currentCount + 1);

    return () => {
      const nextCount = Number(body.dataset.modalScrollLockCount || '1') - 1;

      if (nextCount <= 0) {
        body.style.overflow = body.dataset.modalPreviousOverflow || '';
        delete body.dataset.modalPreviousOverflow;
        delete body.dataset.modalScrollLockCount;
        return;
      }

      body.dataset.modalScrollLockCount = String(nextCount);
    };
  }, [isLocked]);
}
